import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import { buildComponentName } from '../utils';
import Button from '../button';
import Icon from '../icon';
import Input from './input';
export default {
  name: buildComponentName('SearchInput'),
  inheritAttrs: false,
  props: _objectSpread({}, Input.props, {
    prefixCls: {
      type: String,
      default: 'ux-input-search'
    },
    inputPrefixCls: {
      type: String,
      default: 'ux-input'
    },
    enterButton: {
      type: [String, Boolean, Function],
      default: false
    }
  }),
  data: function data() {
    return {
      inputRef: null
    };
  },
  computed: {
    bindProps: function bindProps() {
      var $props = this.$props,
          $attrs = this.$attrs,
          inputPrefixCls = this.inputPrefixCls;
      return _objectSpread({}, $attrs, {}, omit($props, ['inputPrefixCls', 'enterButton']), {
        prefixCls: inputPrefixCls
      });
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onPressenter = this.onPressenter,
          onBlur = this.onBlur;
      return _objectSpread({}, $listeners, {
        pressenter: onPressenter,
        blur: onBlur
      });
    }
  },
  mounted: function mounted() {
    this.inputRef = this.$refs.inputRef;
  },
  methods: {
    getInputRef: function getInputRef() {
      var inputRef = this.inputRef,
          $refs = this.$refs;
      return inputRef || $refs.inputRef;
    },
    focus: function focus() {
      var inputRef = this.getInputRef();

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.getInputRef();

      if (inputRef) {
        inputRef.blur();
      }
    },
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    },
    onSearch: function onSearch(e) {
      var inputRef = this.getInputRef();
      var val = e.target.value;

      if (inputRef && !val) {
        val = inputRef.getInputElement().value;
      }

      this.$emit('search', val, e);
      this.focus();
    },
    onPressenter: function onPressenter(e) {
      this.onSearch(e);
      this.$emit('pressenter', e);
    },
    renderSearchBtn: function renderSearchBtn() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          enterButton = this.enterButton,
          size = this.size,
          disabled = this.disabled,
          onSearch = this.onSearch;

      if (!enterButton) {
        return h(Icon, {
          "attrs": {
            "type": "search"
          },
          "on": {
            "click": disabled ? function () {} : onSearch
          }
        });
      }

      var btnIcon = null;

      if (enterButton === true) {
        btnIcon = h(Icon, {
          "attrs": {
            "type": "search"
          }
        });
      } else if (typeof enterButton === 'function') {
        btnIcon = enterButton(this.$createElement);
      } else {
        btnIcon = enterButton;
      }

      return h(Button, {
        "attrs": {
          "type": "primary",
          "disabled": disabled,
          "size": size
        },
        "class": "".concat(prefixCls, "-button"),
        "on": {
          "click": onSearch
        }
      }, [btnIcon]);
    }
  },
  render: function render() {
    var _inputCls;

    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls,
        enterButton = this.enterButton,
        size = this.size,
        bindProps = this.bindProps,
        bindListeners = this.bindListeners,
        renderSearchBtn = this.renderSearchBtn;
    var inputCls = (_inputCls = {}, _defineProperty(_inputCls, prefixCls, true), _defineProperty(_inputCls, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_inputCls, "".concat(prefixCls, "-").concat(size), size === 'small' || size === 'large'), _inputCls);
    return h(Input, _mergeJSXProps([{
      "ref": "inputRef"
    }, {
      class: inputCls,
      attrs: bindProps,
      on: bindListeners
    }]), [h("template", {
      "slot": "prefix"
    }, [$slots.prefix]), h("template", {
      "slot": "suffix"
    }, [renderSearchBtn()]), h("template", {
      "slot": "addonBefore"
    }, [$slots.addonBefore]), h("template", {
      "slot": "addonAfter"
    }, [$slots.addonAfter])]);
  }
};